import Vue from 'vue'
import Router from 'vue-router'
import Start from './views/Start.vue'
import Login from './views/Login.vue'
import Remember from './views/Remember.vue'
import Trends from './views/Trends'
import Neue from './views/Neue'
import Ablehnen from './views/Ablehnen'
import Deals from './views/Deals'
import Produkte from './views/Produkte'
import ProduktDetails from './views/ProduktDetails'
import Konto from './views/Konto'
import KontoTransaction from './views/KontoTransaction'
import KontoAuszahlen from './views/KontoAuszahlen'
import Profil from './views/Profil'
import Filter from './modals/Filter'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'start', component: Start},
    { path: '/login', name: 'login', component: Login},
    { path: '/remember', name: 'remember', component: Remember},
    { path: '/neue', name: 'neue', component: Neue},
    { path: '/trends', name: 'trends', component: Trends},
    { path: '/ablehnen', name: 'ablehnen', component: Ablehnen},
    { path: '/deals', name: 'deals', component: Deals},
    { path: '/produkte', name: 'produkte', component: Produkte},
    { path: '/produkt_details:produktID', name: 'produkt_details', props: true, component: ProduktDetails},
    { path: '/konto', name: 'konto', component: Konto },
    { path: '/konto_transactions:transID', name: 'konto_transaction', props:true, component: KontoTransaction},
    { path: '/konto_auszahlen', name: 'konto_auszahlen', component: KontoAuszahlen},
    { path: '/profil', name: 'profil', component: Profil},
    { path: '/filter', name: 'filter', component: Filter}
  ]
})
